import Card from "../components/structure/Card";


export const About = () => {
  return (
    <Card>
      <div style={{textAlign: "left"}}>
      <h2>About Trivia Mania</h2>
        <p>Welcome to Trivia Mania, your passport to the world of knowledge, fun, and a dash of friendly competition! We are your one-stop destination for an exciting and intellectually stimulating quiz experience. At Trivia Mania, we believe that learning and entertainment go hand in hand, and we're on a mission to make trivia an addictive adventure for everyone.</p>
        
        <br/>

      <div>
      <h3>📖 Our Story</h3>
        <p>Trivia Mania was born from the idea that trivia is more than just facts and figures—it's a chance to learn, challenge yourself, and have a blast while doing it. Founded in 2023, we set out to create a platform that seamlessly blends education with entertainment, allowing users to explore a wide array of topics while having a great time.</p>
        </div>
        
        <br/>


      <div>
      <h3>🎉 What We Offer</h3>
      <p><strong>Endless Variety</strong>: Trivia Mania offers a vast selection of quiz topics. From history to pop culture, science to sports, and everything in between, there's a quiz for every interest and curiosity.</p>
      <p><strong>Multiple Game Formats</strong>: Choose your preferred quiz format. Go for the classic true/false questions for a quick game, or dive into the multi-faceted world of multiple-choice questions if you're up for a challenge.</p>
      <p><strong>Customization</strong>: Tailor your experience to your liking. Select the difficulty level that suits your expertise, whether you're a novice or a seasoned pro. You can also decide how many questions you want to tackle before the timer runs out.</p>
      <p><strong>Friendly Competition</strong>: Compete with friends, family, and players all over the world to see who reigns supreme in the trivia world. Trivia Mania provides a perfect platform to bond with loved ones or challenge worldwide competitors in a battle of wits.</p>
        <p><strong>Educational Entertainment</strong>: While we emphasize entertainment, Trivia Mania is also designed to be educational. We believe that learning should be engaging, and our quizzes are crafted to ensure that you gain knowledge while having fun.</p>
        </div>
        
        <br/>

      <div>
        <h3>🤗 Join the Trivia Maniacs!</h3>
        <p>Whether you're a trivia master or just looking for a fun way to spend your free time, Trivia Mania is the place to be. Embark on your trivia journey with us, and experience the thrill of knowledge and competition like never before.</p>

        <p>Thank you for choosing Trivia Mania as your trivia destination. We can't wait to see you become the ultimate quiz champion. Start quizzing now!</p>


      </div>


      </div>
    </Card>
  );
};
